import { Listbox } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import React, { useState } from 'react'
import { Control, useController, FieldValues } from 'react-hook-form'

interface SelectProps {
    control: Control<FieldValues, object>
    label?: string
    name: string
    options: { value: any, display: string }[]
    multiple?: boolean
    disabled?: boolean
    enableSearch?: boolean
}
export const SelectInput: React.FC<SelectProps> = ({ control, label, name, options, multiple, disabled, enableSearch }) => {
    let random = `MSelfel`
    const getDisplay = (value: any) => {
        return options.find(option => option.value === value)?.display ?? '- Select -';
    }

    const getDisplayText = (value: any) => {
        return multiple ? (
            value?.length ? value.map((val: any) => getDisplay(val)).join(" , ") : 'Select -'
        ) : (
            getDisplay(value)
        )
    }

    const {
        field: { value: currentValue, onChange, onBlur, ref }, fieldState: { error }
    } = useController({ control, name });


    const value = multiple ? (currentValue ?? []) : (currentValue ?? '')
    const [filter, setFilter] = useState("")
    const FilteredOptions = options?.filter(option => option.display?.search(new RegExp(filter?.trim(),'i')) >= 0)
    return (
        <div className={`relative h-fit w-full ${disabled ? 'pointer-events-none opacity-75': ''}`}>
            <Listbox disabled={disabled} as={'div'} value={value} onChange={onChange} {...{ multiple }}>
                <Listbox.Button title={getDisplayText(value)} className={` flex rounded-t-lg px-2.5 pb-2.5 pt-5 w-full text-sm border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 peer placeholder:text-transparent focus:placeholder:text-gray-500 dark:focus:placeholder:text-gray-600 text-gray-900 bg-gray-100 dark:bg-slate-700 ${error ? 'border-red-500 dark:text-white dark:border-red-500' : 'border-gray-300 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:border-blue-600 dark:hover:border-blue-500 hover:border-blue-600 '}`}>
                    <div className="truncate">
                        <input ref={ref} className="w-0 h-0 focus:ring-0 ring-0 border-none p-0" />
                        {getDisplayText(value)}
                    </div>
                    <div className='box-border ml-auto'>
                        {
                            multiple ? <ChevronUpDownIcon className='h-4 w-4' /> : <ChevronDownIcon className='h-4 w-4' />
                        }
                    </div>
                </Listbox.Button>
                <Listbox.Options onKeyDownCapture={(e) => e.stopPropagation()} onBlur={onBlur} className="absolute pt-0 mt-1 w-full z-20 max-h-60  overflow-auto rounded-md bg-white dark:bg-slate-700 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm ">
                    {
                        enableSearch &&
                        <input value={filter} onChange={(e) => setFilter(e.target.value)} type="text" placeholder='Search ...' className='sticky top-0 shadow-lg text-sm border-0 dark:bg-slate-700 dark:text-white dark:placeholder:text-gray-300  border-b-slate-300 focus:ring-0 p-2 px-3 w-full z-10' />
                    }
                    {FilteredOptions.map((option, optionIndex) => (
                        <Listbox.Option
                            key={optionIndex}
                            className={({ active }) =>
                                `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-blue-100 dark:bg-blue-700 text-blue-900 dark:text-white' : 'text-gray-900 dark:text-white'
                                }`
                            }
                            value={option.value}
                        >
                            {({ selected }) => (
                                <>
                                    <span
                                        className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                            }`}
                                    >
                                        {option.display}
                                    </span>
                                    {selected ? (
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-blue-600 dark:text-blue-400">
                                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                        </span>
                                    ) : null}
                                </>
                            )}
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
                {
                    label && <label htmlFor={random} className={`absolute font-semibold duration-300 transform -translate-y-4 text-[.7rem] top-4 z-10 origin-[0] left-2.5 peer-placeholder-shown:text-sm peer-placeholder-shown:translate-y-0 peer-focus:text-[.7rem] peer-focus:-translate-y-4 ${error ? 'peer-focus:text-red-600 dark:peer-focus:text-red-400 peer-focus:dark:text-blue-500 text-red-500 dark:text-red-400' : 'peer-focus:text-blue-600 dark:peer-focus:text-blue-300 peer-focus:dark:text-blue-500 text-gray-500 dark:text-gray-400'}`}>{label}</label>
                }
            </Listbox>
            {error?.message && (
                <p id="outlined_error_help" className="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">
                    {error?.message?.toString()}
                </p>
            )}
        </div>
    )

}